import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=cdbdd6e2&"
import script from "./dialog.vue?vue&type=script&lang=js&"
export * from "./dialog.vue?vue&type=script&lang=js&"
import style0 from "./dialog.vue?vue&type=style&index=0&id=cdbdd6e2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdbdd6e2')) {
      api.createRecord('cdbdd6e2', component.options)
    } else {
      api.reload('cdbdd6e2', component.options)
    }
    module.hot.accept("./dialog.vue?vue&type=template&id=cdbdd6e2&", function () {
      api.rerender('cdbdd6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/dialog.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/dialog.vue
// module id = SOQt
// module chunks = 0